import moment from "moment";

export default {
  methods: {
    calcDateDueNext(freq, unit, dlast, derating) {
      let days = this.calcDaysSinceLastDate(dlast); // days
      let plan = this.calcDaysPlan(freq, unit); // days
      let derate = parseFloat(derating); // derating factor
      let result = 0;
      let date = null;
      days = parseInt(days);
      plan = parseInt(plan);
      result = plan - days;
      if (result < 0) {
        date = moment().format();
      } else {
        result = result * derate;
        date = moment().add(result, "d");
      }
      date = moment(date).format();
      return date;
    },
    calcDaysSinceLastDate(dlast) {
      let dstr = dlast;
      dstr = moment(dstr);
      let dend = moment().format();
      dend = moment(dend);
      let days = dend.diff(dstr, "days");
      return days;
    },
    calcDaysPlan(freq, unit) {
      let type = unit;
      let days = null;
      if (type === "D") {
        days = 1;
      }
      if (type === "W") {
        days = 7;
      }
      if (type === "M") {
        days = 30;
      }
      if (type === "Y") {
        days = 365;
      }
      days = days * freq;
      return days;
    },
    calcPlanExceed(freq, unit, dlast) {
      let days = this.calcDaysSinceLastDate(dlast);
      let plan = this.calcDaysPlan(freq, unit);
      let result = 0;
      days = parseInt(days);
      plan = parseInt(plan);
      result = (days / plan) * 100;
      result = result.toFixed(1);
      if (isNaN(result)) {
        result = "NE";
      } else {
        if (result > 0) {
          result = result + "%";
        } else {
          result = -1 * result;
          result = result + "% Future";
        }
      }
      return result;
    },
    calcPlanExpect(freq, unit, dlast, dduenext) {
      let daysPrior = this.calcDaysSinceLastDate(dlast);
      let daysPost = this.calcDaysSinceLastDate(dduenext);
      let plan = this.calcDaysPlan(freq, unit);
      let result = 0;
      daysPrior = parseInt(daysPrior);
      daysPost = -1 * parseInt(daysPost);
      plan = parseInt(plan);
      result = ((daysPrior + daysPost) / plan) * 100;
      result = result.toFixed(1);
      if (isNaN(result)) {
        result = "NE";
      } else {
        if (result < 0) {
          result = result + "% [DATE !]";
        } else if (result < 80) {
          result = result + "% [WASTE !]";
        } else if (result > 100) {
          result = result + "% [COMP !]";
        } else {
          result = result + "%";
        }
      }
      return result;
    }
  }
};
